import { Badge } from "@omni/ui/components/Badge/badge.component";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const HeaderButton = ({ className }: Props) => {
    const { t } = useGranite();

    const { open, products, toggle } = useProductComparisonBarContext();

    return (
        <Button
            type={"button"}
            onClick={toggle}
            size="md"
            fullWidth={true}
            className={cn("tw:ring-0! tw:rounded-b-none!", className)}
        >
            <i
                className={cn("las", "tw:mr-2", {
                    "la-angle-down": open,
                    "la-angle-up": !open
                })}
            />

            <span>{t("productComparison.compare")}</span>
            <Badge
                inverse={true}
                className={cn("tw:ml-2")}
            >
                {products?.length || 0}/6
            </Badge>
        </Button>
    );
};
